import Backup from './backup/backup.module'
import Branch from './branch/branch.module'
import Client from './client/client.module'
import Integrator from './integrator/integrator.module'
import Fileset from './fileset/fileset.module'
import Flash from './flash/flash.module'
import Group from './group/group.module'
import Grouppermission from './grouppermission/grouppermission.module'
import Organization from './organization/organization.module'
import Orphan from './orphan/orphan.module'
import Permission from './permission/permission.module'
import Retention from './retention/retention.module'
import Rpiclient from './rpiclient/rpiclient.module'
import Scanresult from './scanresult/scanresult.module'
import Schedule from './schedule/schedule.module'
import Socket from './socket/socket.module'
import System from './system/system.module'
import Token from './token/token.module'
import User from './user/user.module'
import UserOrg from './userorg/userorg.module'
import version from './version'

import { createStore } from 'vuex'

// Exported as a plain Vuex instance: @quasar/app-vite v3's store loader is Pinia-only,
// so this is installed via src/boot/store.js and imported directly where needed.
export default createStore({
  modules: {
    Backup,
    Branch,
    Client,
    Fileset,
    Flash,
    Group,
    Grouppermission,
    Integrator,
    Organization,
    Orphan,
    Permission,
    Retention,
    Rpiclient,
    Scanresult,
    Schedule,
    Socket,
    System,
    Token,
    User,
    UserOrg
  },
  state: {
    version
  },
  actions: {
  },
  getters: {
  },
  // enable strict mode (adds overhead!)
  // for dev mode only
  strict: import.meta.env.QUASAR_DEBUG
})
